module.exports = __webpack_public_path__ + "ec7cc0b8.svg";